// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"c23c38b4","265":"35d62f93","460":"1f3d729d"}[chunkId] + ".css";
};